import { render, staticRenderFns } from "./PositionRelatedOffers.vue?vue&type=template&id=7be3c723"
import script from "./PositionRelatedOffers.vue?vue&type=script&lang=js"
export * from "./PositionRelatedOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports